export default __webpack_public_path__ + "static/130-edf541e41966b1f4c7e9d0044c267893.gif";